import axios from 'axios'
import qs from 'qs';
// import jsuper from "@/assets/js/jsuperV2.js";
// import sunny from "@/assets/js/sunny.js";
// import { utils } from "./tool"
/**
 * 配置项
 */


//是否正式环境
const isOfficial = location.href.indexOf("a.super.cn") != -1


const superTestUrl = {
  //base.url请求
  apiUrl: "https://a.super.cn/previewCourse/api/",
  // apiUrl: "http://192.168.20.8:7060/previewCourse",
  // apiUrl: "http://192.168.20.8:7060",
  //  apiUrl: "http://192.168.0.8/",
  //  apiUrl: "https://live.super.cn",

  //图片地址
  picUrl: "http://192.168.0.8/",
}

const superOfficialUrl = {
  //base.url请求
  apiUrl: "https://a.super.cn/previewCourse/api/",
  // apiUrl: "http://192.168.0.8:80",

  //图片地址
  picUrl: "https://a.super.cn/previewCourse/api/",
}

const superBaseURL = isOfficial ? superOfficialUrl : superTestUrl
const instance = axios.create({
  baseURL: superBaseURL.apiUrl,
  withCredentials: false,// 跨域 cookie
  timeout: 15000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})
const request = {}
/*
const methods = ['post', 'put', 'patch', 'delete', 'get', 'head']
*/

request['post'] = (url, params, headers) => {
  return instance.post(url, qs.stringify(params), { headers }).then(res => {
    return res.data
  }).catch(async e => {
    throw e
  })
}

request['get'] = (url, params, headers) => {
  return instance.get(url, { params, headers }).then(res => {
    return res.data
  }).catch(async e => {
    throw e
  })
}

request['getSuperId'] = () => {
  // let ciphertext = "b6289bc8878a00732f217422005b21c8"
  // if (location.href.indexOf('192.168.13.27') != -1) {
  //   ciphertext = "9ffbed99de756b1b8ff0d02ea88eedae"
  // } else if (location.href.indexOf('a.super.cn') != -1) {
  //   ciphertext = "8e1586fcae9fb7a3c0488ca57a8bd611"
  // }
  // if (utils.isSuperBrowser) {
  //   jsuper.config({
  //     // ciphertext: window.location.host.indexOf('192.168.0.36') != -1 ? '2f234e371fba2bb3acd3681c99600950' : 'e24bd0485b057280f7ab39ec2f5b3aba',
  //     //  "本地192.168.10.172",
  //     ciphertext,
  //     // ciphertext: "90f9b602be4426b7b5a55348614262ef",
  //     //  "正式网",
  //     // ciphertext: "2f234e371fba2bb3acd3681c99600950",
  //     // debug: 1,
  //     success: function () {
  //       jsuper.userInfo({
  //         success: function (data) {
  //           if (data.identity) {
  //             localStorage.setItem('identity', data.identity)
  //           }
  //         }
  //       });
  //     },
  //     fail: function () {
  //       alert('登录失败，请稍后再试。');
  //     }
  //   });

  // }
  // else { //非表表浏览器
  //   // let identity = '';
  //   // let identity = 'AA1F6A0AF2F29743CC35A535F2E69FB3';

  //   // alert("请登录超级课程表APP打开此活动");

  //   let openId = sunny.weixin.getUserOpenId(process.env.VUE_APP_UserOpenIdUrl, '', process.env.VUE_APP_pwd, '2')
  //   localStorage.setItem('identity', openId)
  // }
}
/** 
 * response 拦截器-每次数据请求都会触发
 */
// instance.interceptors.response.use(
//     response => {
//     //  console.log(response)
//     return response;
//     },
//     error => {
//       if (error.response) {
//         throw error;
//       }
//       return Promise.reject(error)   // 返回接口返回的错误信息
//     });


export default request
